import functions from '../../functions';

if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    
    const { 
        InspectorControls,
        MediaUpload,
    } = window.wp.editor;
    
    const { 
        PanelBody, 
        IconButton, 
        TextControl,
        Button
    } = window.wp.components;

    const { Fragment } = window.wp.element;

    registerBlockType('custom-gutenberg/single-image', {
        // built-in attributes
        title: 'Single Image',
        description: 'Single Image',
        icon: '',
        category: 'containers',
        example: {},

        // custom attributes
        attributes: {
            image: {
                type: 'string',
                default: ''
            }, 
            alt: {
                type: 'string',
                default: ''
            }
        },

        // built-in functions
        edit({ attributes, setAttributes, className }) {

            const {
                image, 
                alt,
                classes,
            } = attributes;

            className = functions.getClassNames(className);
            if(classes != className) setAttributes({classes: className});


            // custom functions
             const onSelectImage = (image) => {
                setAttributes({ image: image.sizes.full.url });
            };

            const onAltChange = (alt) => {
                setAttributes({ alt: alt });
            };

            const onRemoveImage = () => {
                setAttributes({image: '' });
                setAttributes({ alt: '' });
            };
                
            return ([
                <Fragment>
                    <InspectorControls style={ { marginBottom: '40px' } }>
                        <PanelBody title={ 'Settings' }>
                                 <div style={{ marginBottom: '20px' }}>
                                    <p><strong>Select Image</strong></p>
                                    <MediaUpload 
                                        onSelect={(imageObj) => onSelectImage(imageObj)}
                                        type="image"
                                        value={image}
                                        render={({ open }) => (
                                            <div>
                                                {image && (
                                                    <div>
                                                        <figure style={{ margin: 0 }}>
                                                            <img src={image} style={{ maxWidth: '200px', maxHeight: '150px', objectFit: 'cover' }} />
                                                        </figure>
                                                            <Button 
                                                                onClick={() => onRemoveImage()} 
                                                                className="button"
                                                                style={{ marginRight: '10px' }}
                                                            >
                                                            Remove
                                                        </Button>
                                                        <br/>
                                                    </div>
                                                )}
                                                <IconButton
                                                    onClick={open}
                                                    icon="upload"
                                                    className="editor-media-placeholder__button is-button is-default is-large"
                                                >
                                                    Select Image
                                                </IconButton>
                                            </div>
                                        )} 
                                    />
                                    <br />
                                    <p><strong>Alt text:</strong></p>
                                    <TextControl 
                                        value={alt} 
                                        onChange={(value) => onAltChange(value)}
                                    />
                                </div>
                        </PanelBody>
                    </InspectorControls>
                </Fragment>
                ,
                <div className={ "single-image light-rectangle-bg " + (classes ? ' ' + classes : '') }>
                    <figure className="size-full">
                        <img src={ image } alt={ alt } className="cover-image"/> 
                    </figure>
                </div> 
            ]
            );
        },

        save({ attributes }) {

            const {
                image,
                alt,
                classes,
            } = attributes;

            return (
                <div className={ "single-image light-rectangle-bg" + (classes ? ' ' + classes : '') }>
                    <figure className="size-full">
                        <img src={ image } alt={ alt } className="cover-image lozad"/>
                    </figure>
                </div>
            );
        },
    });
}